import script from "./InvoiceTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTemplate.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTemplate.vue?vue&type=style&index=0&id=596770ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596770ad"]])

export default __exports__